/** Visualization manifest shared by the UI, the presets and the renderer. */
import type { ParamDef } from './params';
import type { BlendMode } from './scene';

export type VizKind = 'native' | 'isf' | 'butterchurn';

export interface VisualizationDef {
  id: string;
  name: string;
  description: string;
  params: ParamDef[];
  /** GLSL body appended to PRELUDE (native kind). */
  fragment: string;
  /** 'native' (default), 'isf' (imported shader), 'butterchurn' (MilkDrop preset). */
  kind?: VizKind;
  /** Source for non-native kinds (ISF text, MilkDrop preset JSON). */
  source?: string;
  /** e.g. 'energy:high', 'style:lasers'. Used by Auto show and the browser. */
  tags?: string[];
  /** Author/licence attribution for third-party content. */
  credit?: string;
  /**
   * 'background' fills the whole screen (plasma, tunnels, fractals). 'element' draws shapes on
   * black (bars, rings, particles, beams) and is meant to sit over a background with the 'over'
   * blend. Defaults to 'background'.
   */
  role?: VizRole;
  /** Blend mode to use when it's added as a layer (e.g. 'multiply' for a silhouette). */
  blend?: BlendMode;
}

export type VizRole = 'background' | 'element';

export function vizRole(v: Pick<VisualizationDef, 'role'> | undefined): VizRole {
  return v?.role ?? 'background';
}
